<template>
  <div class="page noselect">
    <div class="flex">
      <div class="left">
        <div class="title">玉米模型</div>
        <!-- <div style="width: 300px; height: 400px"></div> -->
        <div class="one">
          <div
            class="model"
            ref="fbxContainer"
            @mouseenter="mouseMode = true"
            @mouseleave="mouseMode = false"
          ></div>
           <div class="zhouqi">乳熟期</div>
          <div class="mx-info flexCol alit justc abs1">
            <div class="flex alit">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E5%85%A8%E9%83%A8%E6%96%B9%E6%A1%88%402x.png"
                alt=""
              />
              <div class="tt">全部方案</div>
            </div>
            <div class="flex">
              <div class="num">17</div>
              <div class="num-unit">项</div>
            </div>
          </div>
          <div class="mx-info flexCol alit justc abs2">
            <div class="flex alit">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E6%96%BD%E8%82%A5%E7%81%8C%E6%BA%89%402x.png"
                alt=""
              />
              <div class="tt">施肥灌溉</div>
            </div>
            <div class="flex">
              <div class="num">102</div>
              <div class="num-unit">次</div>
            </div>
          </div>
          <div class="mx-info flexCol alit justc abs3">
            <div class="flex alit">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E6%A4%8D%E4%BF%9D%E6%96%B9%E6%A1%88%402x.png"
                alt=""
              />
              <div class="tt">植保方案</div>
            </div>
            <div class="flex">
              <div class="num">22</div>
              <div class="num-unit">次</div>
            </div>
          </div>
          <div class="mx-info flexCol alit justc abs4">
            <div class="flex alit">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E7%97%85%E8%99%AB%E5%AE%B3%E9%A2%84%E8%AD%A6%402x.png"
                alt=""
              />
              <div class="tt">病虫害预警</div>
            </div>
            <div class="flex">
              <div class="num">39</div>
              <div class="num-unit">条</div>
            </div>
          </div>
          <div class="mx-info flexCol alit justc abs5">
            <div class="flex alit">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E5%BD%93%E5%B9%B4%E9%99%8D%E9%9B%A8%402x.png"
                alt=""
              />
              <div class="tt">当年降雨</div>
            </div>
            <div class="flex">
              <div class="num">165mm</div>
            </div>
          </div>
          <div class="mx-info flexCol alit justc abs6">
            <div class="flex alit">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E5%9C%9F%E5%A3%A4%E5%A2%92%E6%83%85%402x.png"
                alt=""
              />
              <div class="tt">土壤墒情</div>
            </div>
            <div class="flex">
              <div class="num">粉砂质粘土</div>
            </div>
          </div>
       
        </div>

        <div class="title">玉米分析</div>
        <div class="two flexCol alit">
          <img
            class="jiexi-you"
            src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E4%BC%98%402x.png"
            alt=""
          />
          <div class="jiexi flexCol alit justc">
           <div class="text">
              三叶期玉米株高0.57米，较标准值超出0.02米，整租0.57厘米，较标准值粗0.02厘米，三片嫩绿叶平展，根系初具规模，茎秆粗壮挺直，整体长势健壮，叶片油绿有光泽，三片嫩绿叶平展，根系初具规模，基秆粗壮挺直，整体长势健壮，叶片油绿有光泽。(遥感监测:
              如植株的高矮、粗细，叶片的大
              小、颜色和繁茂程度等)三叶期玉米株高0.57米，较标准值超出0.02米，整租0.57厘米，较标准值粗0.02厘米，三片嫩绿叶平展，三叶期玉米株高0.57米，较标准值超出0.02米，整租0.57厘米，较标准值粗0.02厘米，三片嫩绿叶平展，三叶期玉米株高0.57米，较标准值超出0.02米，整租0.57厘米，较标准值粗0.02厘米，三片嫩绿叶平展，
            </div>
          </div>
        </div>
      </div>
      <div class="right flexCol justb">
        <div class="">
          <img
            class="ymjd"
            src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E4%BD%9C%E7%89%A9%E9%98%B6%E6%AE%B5%402x.png"
            alt=""
          />
        </div>
        <!-- <div class="flexCol">
          <div class="flex">
            <div class="list" v-for="item in zq">
              {{ item }}
            </div>
          </div> -->
          <div class="title nszq">农事指导</div>
          <div class="ns-cont flex justb alit">
            <div class="jd-list flexCol alit justc" v-for="item in jdList">
              <div class="flex alit">
                <img
                  src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E7%BB%84%202%402x%282%29.png"
                  alt=""
                />
                <div class="jd-title" v-html="item.title"></div>
                <img
                  src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E7%BB%84%202%402x%281%29.png"
                  alt=""
                />
              </div>
              <div class="jd-cont">
                <div class="jd-cont-text">{{ item.value }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as THREE from "three";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { OrbitControls } from "three/addons/controls/OrbitControls.js"; //相机控件
import { InstancedMesh } from "three";
export default {
  data() {
    return {
      zq: [
        "吐丝期",
        "三叶期",
        "拔节期",
        "小喇叭口期",
        "大喇叭口期",
        "抽丝期",
        "吐丝期",
        "子粒成熟期",
        "成熟期",
        "完熟期",
      ],
      width: "",
      height: "",
      scene: "",
      camera: "",
      renderer: "",
      fbxModel: {},
      mouseMode: false,
      jdList: [
        {
          title: "当前阶段",
          value: "",
        },
        {
          title: "下一个阶段",
          value: "",
        },
        {
          title: "距离下一阶段",
          value: "",
        },
        {
          title: "下一次灌溉日期",
          value: "",
        },
        {
          title: "下一次灌溉量<br/>(亩均)",
          value: "",
        },
        {
          title: "下一次施肥日期",
          value: "",
        },
        {
          title: "下一次施肥<br/>氮磷钾量比",
          value: "",
        },
      ],
    };
  },
  mounted() {
    this.initThree();
    this.getNowStage();
  },
  beforeDestroy() {
    this.unloadModel();
  },
  methods: {
    getNowStage() {
      this.$request("iot/grow-model/getStage").then((res) => {
        this.jdList[0].value = res.data.currentStage;
        this.jdList[1].value = res.data.nextStage;
        this.jdList[2].value = res.data.nextDay + "天";
        this.jdList[3].value = this.utils.changeTimeNoHms(res.data.nextDate);
        this.jdList[4].value = res.data.nextWater;
        this.jdList[5].value = this.utils.changeTimeNoHms(
          res.data.nextFeedDate
        );
        this.jdList[6].value = res.data.nextFeed;
      });
    },
    initThree() {
      const width = this.$refs.fbxContainer.clientWidth;
      const height = this.$refs.fbxContainer.clientHeight;
      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(90, width / height, 0.1, 3000);
      const renderer = new THREE.WebGLRenderer({
        powerPreference: "high-performance", // 强制高性能模式
        antialias: false, // 关闭抗锯齿
        logarithmicDepthBuffer: true, // 解决深度冲突（大场景适用）
      });
      renderer.setClearColor("#fff", 0); // 设置透明（第二个参数 0 表示完全透明）
      renderer.setSize(width, height);

      //点光源：两个参数分别表示光源颜色和光照强度
      // 参数1：0xffffff是纯白光,表示光源颜色
      // 参数2：1.0,表示光照强度，可以根据需要调整
      const pointLight = new THREE.AmbientLight(0xffffff, 6.0);
      // pointLight.decay = 6.0;
      // pointLight.intensity = 2
      //点光源位置
      pointLight.position.set(200, 100, 300); //点光源放在x轴上
      scene.add(pointLight); //点光源添加到场景中
      // 光源辅助观察
      // const pointLightHelper = new THREE.PointLightHelper(pointLight, 10);
      // scene.add(pointLightHelper);

      this.$refs.fbxContainer.appendChild(renderer.domElement);
      camera.position.x = 5;

      camera.position.y = 2;

      // camera.position.set(0, 5, 0);
      //相机观察目标指向Threejs 3D空间中某个位置
      camera.lookAt(0, 0, 0); //坐标原点
      renderer.shadowMap.enabled = false; // 完全关闭阴影
      scene.traverse((obj) => {
        if (obj.isLight) obj.castShadow = false; // 禁用光源阴影
      });

      this.scene = scene;
      this.camera = camera;
      this.renderer = renderer;

      this.loadFBX();

      // AxesHelper：辅助观察的坐标系
      // const axesHelper = new THREE.AxesHelper(100);
      // scene.add(axesHelper);

      //创建相机控制对象
      const controls = new OrbitControls(camera, renderer.domElement);
      // // 如果OrbitControls改变了相机参数，重新调用渲染器渲染三维场景
      // controls.addEventListener("change", function () {
      //   renderer.render(scene, camera); //执行渲染操作
      // }); //监听鼠标、键盘事件
      // controls.enableDamping = true; // 平滑惯性移动
    },
    loadFBX() {
      let that = this;
      const loader = new FBXLoader();
      // const loader = new GLTFLoader();
      loader.load(
        "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/mode/yumi%E6%A0%87%E5%87%86%E6%B8%B2%E6%9F%93862.fbx", // 你的 FBX 文件路径
        (object) => {
          object.traverse((child) => {
            if (child.isMesh) {
              child.material.side = THREE.DoubleSide;
              // 如果材质是数组（如多个子材质）
              if (Array.isArray(child.material)) {
                child.material.forEach((mat) => {
                  mat.side = THREE.DoubleSide;
                });
              }

              // 反转几何体的法线（适用于单面建模的FBX）
              // child.geometry.computeVertexNormals(); // 确保法线已计算
              // child.geometry.normalsNeedUpdate = true;

              // 如果背面仍然黑暗，可以尝试翻转法线
              // const normals = child.geometry.attributes.normal;
              // for (let i = 0; i < normals.count; i++) {
              //   normals.setX(i, -normals.getX(i));
              //   normals.setY(i, -normals.getY(i));
              //   normals.setZ(i, -normals.getZ(i));
              // }
              // normals.needsUpdate = true;
            }
          });
          // console.log(object);
          object.position.y = -1.2;
          // object.position.z = -30; // 根据模型调整位置
          // object.rotation.x = -Math.PI / 2; // 根据需要调整旋转角度
          object.scale.set(1.2, 1.2, 1.2); // 根据模型大小调整缩放比例
          that.scene.add(object);
          that.fbxModel = object;
          //  that.renderer.render(that.scene, that.camera);
          this.animate();
        },
        (xhr) => {
          // console.log((xhr.loaded / xhr.total) * 100 + "% loaded"); // 加载进度回调函数，可选
          //  this.initThree();
        },
        (error) => {
          console.error("An error happened", error); // 加载错误回调函数，可选
        }
      );
    },
    animate() {
      requestAnimationFrame(this.animate);

      // 在这里可以添加对模型的旋转或其他动画效果
      if (this.fbxModel && !this.mouseMode) {
        // this.fbxModel.rotation.x += 0.01;
        this.fbxModel.rotation.y += 0.01;
      }
      this.renderer.render(this.scene, this.camera);
    },
    // 卸载模型
    unloadModel() {
      if (!this.fbxModel) return;

      // 1. 从场景移除
      this.scene.remove(this.fbxModel);

      // 2. 释放几何体、材质、贴图
      this.fbxModel.traverse((child) => {
        if (child.isMesh) {
          child.geometry.dispose();
          if (Array.isArray(child.material)) {
            child.material.forEach((m) => m.dispose());
          } else {
            child.material.dispose();
          }
        }
      });
      // 3. 清除引用
      this.fbxModel = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.right {
  width: 1350px;
  margin-left: 30px;
  margin-top: 65px;
  .ymjd {
    width: 1350px;
    height: 640px;
    image-rendering: pixelated;
  }
  .jd-list {
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E9%98%B6%E6%AE%B5%E5%88%97%E8%A1%A8%402x.png");
    background-size: 100% 100%;
    width: 174px;
    height: 137px;

    .jd-cont {
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E5%AE%B9%E5%99%A8%402x.png");
      background-size: 100% 100%;
      width: 160px;
      height: 52px;
      margin-top: 15px;
      .jd-cont-text {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        line-height: 52px;
        text-align: center;
        background: linear-gradient(
          90deg,
          #ffffff 4%,
          #2abfe6 78%,
          #2abfe6 95%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .jd-title {
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-size: 14px;
      height: 40px;
      margin-top: 18px;
      background: linear-gradient(
        180deg,
        #ffffff 0%,
        #ffeebd 75%,
        #ffa169 100%
      );
      font-weight: 900;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .ns-cont {
    width: 1300px;
    height: 200px;
    padding: 0 20px;
    background: linear-gradient(
      180deg,
      rgba(55, 157, 230, 0.3) 0%,
      rgba(25, 101, 200, 0.3) 100%
    );
  }
  .list {
    width: 110px;
    height: 37px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E5%88%87%E5%9B%BE%2011%402x.png");
    background-size: 100% 100%;
    font-family: PingFang SC, PingFang SC;
    font-weight: normal;
    font-size: 16px;
    color: #32c5ff;
    line-height: 37px;
    text-align: center;
    margin-right: 20px;
    cursor: pointer;
  }
  .nszq {
    width: 925px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E5%86%9C%E4%BA%8B%E5%91%A8%E6%9C%9F%402x.png");
    margin: 20px 0;
  }
}
.left {
  margin-left: 20px;
  margin-top: 10vh;
  width: 382px;
  height: 85vh;
  // background: rgba($color: #c8eebc, $alpha: 0.6);
  .title {
    width: 320px;
  }
  .one {
    width: 382px;
    height: 400px;

    background-image: url(" https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E5%B7%A6%E4%B8%8A%E8%83%8C%E6%99%AF%402x%20%282%29.png");
    // background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E5%88%87%E5%9B%BE%201%402x.png");
    // background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E6%A8%A1%E5%9E%8B%E8%83%8C%E6%99%AF%402x.png");
    background-size: 100% 100%;
    margin: 15px 0;
    position: relative;
    .model {
      width: 382px;
      height: 400px;
    }
    .zhouqi {
      width: 82px;
      height: 30px;
      background: #1699e6;
      box-shadow: 0px 0px 4px 0px rgba(95, 148, 244, 0.34);
      border-radius: 0px 0px 0px 0px;
      border: 1px solid;
      border-image: linear-gradient(
          147deg,
          rgba(110, 183, 245, 1),
          rgba(55, 107, 235, 1)
        )
        1 1;

      font-family: JiangChengXieHei, JiangChengXieHei;
      font-weight: normal;
      font-size: 14px;
      color: #d1e4ff;
      text-align: center;
      line-height: 30px;
      position: absolute;
      left: 155px;
      top: -10px;
    }
    .mx-info {
      width: 90px;
      height: 50px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E6%A8%A1%E5%9E%8B%E5%B7%A6%E5%8F%B3%E8%83%8C%E6%99%AF%402x.png");
      background-size: 100% 100%;
      position: absolute;
      .tt {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 11px;
        color: #ffffff;
      }
      img {
        width: 14px;
        height: 14px;
        margin-right: 3px;
      }
      .num {
        font-family: DIN-BoldItalic, DIN-BoldItalic;
        font-weight: 900;
        font-size: 16px;
        color: #edfbff;
        text-align: center;
        background: linear-gradient(180deg, #fff600 21%, #fffca2 83%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-style: italic;
        padding-right: 3px;
        margin-right: 5px;
      }
      .num-unit {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 10px;
        color: #ffffff;
        margin-top: 8px;
      }
    }
    .abs1 {
      top: 40px;
      left: 20px;
    }
    .abs2 {
      top: 150px;
      left: 0px;
    }
    .abs3 {
      top: 260px;
      left: 20px;
    }
    .abs4 {
      top: 40px;
      right: 20px;
    }
    .abs5 {
      top: 150px;
      right: 0px;
    }
    .abs6 {
      top: 260px;
      right: 20px;
    }
  }
  .two {
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E6%A8%A1%E5%9E%8B%E8%A7%A3%E6%9E%90%E8%83%8C%E6%99%AF%402x.png");
    background-size: 100% 100%;
    width: 382px;
    height: 364px;
    margin-top: 10px;
    .jiexi-you {
      width: 84px;
      height: 84px;
      position: relative;
      z-index: 10;
    }
    .jiexi {
      width: 320px;
      height: 275px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E6%A8%A1%E5%9E%8B%E8%A7%A3%E6%9E%90%E5%86%85%E9%83%A8%E8%83%8C%E6%99%AF%402x%20%281%29.png");
      background-size: 100% 100%;
      margin-top: -22px;

      .text {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        line-height: 27px;
        width: 275px;
        height: 225px;
        overflow: auto;
      }

      /* 设置滚动条整体样式 */
      .text::-webkit-scrollbar {
        width: 8px;
        /* 垂直滚动条宽度 */
        height: 8px;
        /* 水平滚动条高度 */
      }

      /* 设置滚动条轨道 */
      .text::-webkit-scrollbar-track {
        background: rgba(202, 199, 199, 0.1);
        /* 轨道背景色 */
        border-radius: 4px;
        /* 圆角 */
      }

      /* 设置滚动条滑块 */
      .text::-webkit-scrollbar-thumb {
        background: #5d70db;
        /* 滑块颜色 */
        border-radius: 4px;
        /* 圆角 */
      }

      /* 设置鼠标悬停在滑块上的样式 */
      .text::-webkit-scrollbar-thumb:hover {
        background: #5166db;
        cursor: pointer;
        /* 悬停时颜色 */
      }
    }
  }
}
.page {
  width: 100vw;
  height: 100vh;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%9B%9B%E6%83%85%E8%83%8C%E6%99%AF%402x.png");
  background-size: 100% 100%;
  overflow: hidden;
}
</style>